import {TabPanel, TabView} from "primereact/tabview";
import React from "react";

export default function NsScrollableTabs({
                                             activeIndex,
                                             onTabChange,
                                             scrollableTabs
                                         }) {

    return (
        <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => onTabChange(e)}
            scrollable
        >
            {scrollableTabs.filter(b => b).map((tab, idx) => {
                return (
                    <TabPanel key={idx} header={tab.title}>
                        {tab.content}
                    </TabPanel>
                );
            })}
        </TabView>
    );

}